import {
  StepLabel,
  Stepper,
  Step,
  StepConnector,
  Typography,
} from "@material-ui/core";
import { green, orange } from "@material-ui/core/colors";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  EventNote,
  GroupAdd,
  EventAvailable,
  Today,
  VideoLabel,
} from "@material-ui/icons";
import clsx from "clsx";
import React from "react";
var moment = require("moment");

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundColor: orange[500],
    },
  },
  completed: {
    "& $line": {
      backgroundColor: green[500],
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  active: {
    backgroundColor: orange[500],
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundColor: green[500],
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <Today />,
    2: <EventNote />,
    3: <EventAvailable />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return [
    moment().subtract(3, "days").format("DD/MM"),
    moment().format("DD/MM"),
    moment().add(4, "days").format("DD/MM"),
  ];
}

export default function EvaluationDatesChart() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(1);
  const steps = getSteps();

  return (
    <div>
      <Typography
        style={{ paddingTop: 12, paddingLeft: 12 }}
        variant="h6"
        color="textPrimary"
      >
        Fechas de evaluación
      </Typography>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<ColorlibConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}
